
import { Loader2 } from 'lucide-react';

const MiniAppLoader = () => {
  console.log('🔄 MiniAppLoader is rendering');
  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: '#1a1f36' }} // Explicit navy fallback
    >
      <div 
        className="text-center rounded-lg p-8 border max-w-md mx-4"
        style={{ 
          backgroundColor: '#2d3748',
          borderColor: '#4a5568'
        }}
      >
        <div className="flex items-center justify-center space-x-3 mb-4">
          <Loader2 
            className="animate-spin" 
            size={32} 
            style={{ color: '#e2c044' }}
          />
        </div>
        <h2 
          className="text-xl font-bold mb-2"
          style={{ color: '#e2c044' }}
        >
          Loading BroMentum...
        </h2>
        <p 
          className="text-sm"
          style={{ color: '#9ca3af' }}
        >
          Initializing Mini-App...
        </p>
        <div 
          className="mt-4 w-full rounded-full h-2"
          style={{ backgroundColor: '#4a5568' }}
        >
          <div 
            className="h-2 rounded-full animate-pulse" 
            style={{ 
              width: '60%',
              backgroundColor: '#e2c044'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MiniAppLoader;
